export default __webpack_public_path__ + "static/home-specialty-hawaii-f1d5be087014d83b1be2e863032ba50b.jpg";